import { cn } from "@newxsystems/shared";
import { BlockActions } from "../../../shared/components/BlockActions/BlockActions";
import { BlockCommonContent } from "../../../shared/components/BlockCommonContent/BlockCommonContent";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import { ResponsiveBlockGrid } from "../../../shared/components/ResponsiveBlockGrid/ResponsiveBlockGrid";
import { ResponsiveBlockGridItem } from "../../../shared/components/ResponsiveBlockGridItem/ResponsiveBlockGridItem";
import { TestimonialCard } from "../TestimonialCard/TestimonialCard";
import type { ITestimonialGridStandardProps } from "./TestimonialGridStandard.props";

export const TestimonialGridStandard = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: ITestimonialGridStandardProps) => {
  const hasCommonContent = Boolean(eyebrow || heading || description);
  const hasActions = Boolean(buttons?.length);
  const hasIntro = hasCommonContent || hasActions;

  return (
    <BlockContainer anchorId={anchorId} parentClass={parentClass} spacing={spacing}>
      {hasCommonContent ? (
        <BlockCommonContent
          alignment={alignment}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingLevel="h2"
        />
      ) : null}
      {hasActions ? (
        <BlockActions
          actions={buttons ?? []}
          alignment={alignment}
          className={hasCommonContent ? "mt-8" : undefined}
        />
      ) : null}
      <ResponsiveBlockGrid
        className={cn("gap-4 md:gap-6", hasIntro && "mt-12 md:mt-16")}
        columnCount={columnCount}
      >
        {items.map((item, index) => (
          <ResponsiveBlockGridItem key={`${item.name}-${index}`} span={item.columnSpan}>
            <TestimonialCard item={item} />
          </ResponsiveBlockGridItem>
        ))}
      </ResponsiveBlockGrid>
    </BlockContainer>
  );
};

TestimonialGridStandard.displayName = "TestimonialGrid::TestimonialGridStandard";
